import React, { useState, useEffect } from "react";
import {Grid} from '@material-ui/core';
import Button from '../Button'
import { connect } from 'react-redux';
import {
    loginStep1ConfirmationCode,
    resendConfirmationCodeForSocialLogin,
    resendConfirmationCodeForSocialLoginReset,
    getToken,
    getTokenReset,
} from "../../actions/security";
import { Alert as MuiAlert} from '@material-ui/lab';
import {Snackbar} from '@material-ui/core';
import {loginRoutes} from "../../Routes/LoginRoute";
import loadable from "../Lazy";


const Alert = props => {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
};
const Recaptcha = loadable(() => import('../../components/App/Recaptcha'));

const LoginResendButton = ({
    mobile,
    getTokenSuccess,
    token,
    getToken,
    getTokenReset,
    loginStep1ConfirmationCode,
    loginStep1ConfirmationCodeReset,
    loginStep1ConfirmationCodeError,
    loginStep1ConfirmationCodeSuccess,
    loginStep1ConfirmationCodeRedirect
}) => {
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [sendSuccessMessage, setSendSuccessMessage] = useState('');
    const [loginToken, setLoginToken] = useState('');

    const handleSubmit = (recaptchaToken) => {
        setIsSubmitting(true)
        loginStep1ConfirmationCode({
            username: mobile.replace(/[^0-9]/g, ''),
            token: loginToken,
            recaptchaToken: recaptchaToken,
            redirect: `${window.location.origin}/secure/account/received`
        })
    }

    const handleAlertClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setErrorMessage(null);
        setSendSuccessMessage(null);
    };


    useEffect(() => {
        getToken({name: 'gift_ya_send_code'})
    }, [getToken]);

    useEffect(() => {
        if (getTokenSuccess) {
            setLoginToken(token);
            getTokenReset();
        }
    }, [getTokenSuccess, getTokenReset, token])


    useEffect(() => {
        if (loginStep1ConfirmationCodeSuccess) {
            // Redirect to code confirmation page
            setSendSuccessMessage("A new confirmation code has been sent to your phone number.");
            setIsSubmitting(false);
        }
    }, [loginStep1ConfirmationCodeSuccess, loginStep1ConfirmationCodeRedirect]);

    useEffect(() => {
        if (loginStep1ConfirmationCodeError) {
            // Error occurred when sending code
            setErrorMessage('There was an error resending the login code. Please try again or contact customer service.');
            setIsSubmitting(false);
        }
    }, [loginStep1ConfirmationCodeError]);


    return (
        <>
            <Snackbar
                autoHideDuration={8000}
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                open={!!errorMessage} onClose={handleAlertClose}
            >
                <Alert onClose={handleAlertClose} severity="error">{errorMessage}</Alert>
            </Snackbar>

            <Snackbar
                autoHideDuration={8000}
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                open={!!sendSuccessMessage} onClose={handleAlertClose}
            >
                <Alert onClose={handleAlertClose} severity="success">{sendSuccessMessage}</Alert>
            </Snackbar>

            <Grid container spacing={1} justifyContent="space-between">
                <Grid item>
                    <Recaptcha
                        onSubmit={handleSubmit}
                    >
                        {({submitAction}) => {
                            const handleClick = (e) => {
                                setIsSubmitting(true);
                                submitAction(e);
                            }
                            return (
                                <Button
                                    loading={isSubmitting}
                                    onClick={handleClick}
                                    disabled={isSubmitting}
                                    color="primary"
                                    variant="text"
                                    size="small"
                                >
                                    Resend
                                </Button>
                            );
                        }}
                    </Recaptcha>
                </Grid>
                <Grid item>
                    <Button
                        color="primary"
                        variant="text"
                        size="small"
                        href={loginRoutes.root}>Change Number</Button>
                </Grid>
            </Grid>
        </>
    )
}

export default connect(
    (state) => ({
        getTokenSuccess: state.security.getTokenSuccess,
        getTokenError: state.security.getTokenError,
        token: state.security.token,
        loginStep1ConfirmationCodeError: state.security.loginStep1ConfirmationCodeError,
        loginStep1ConfirmationCodeSuccess: state.security.loginStep1ConfirmationCodeSuccess,
        loginStep1ConfirmationCodeRedirect: state.security.loginStep1ConfirmationCodeRedirect
    }),
    {
        loginStep1ConfirmationCode,
        resendConfirmationCodeForSocialLogin,
        resendConfirmationCodeForSocialLoginReset,
        getToken,
        getTokenReset
    }
)(LoginResendButton);